import { createAction } from '../../techstyle-shared/redux-core';

export const trackDmgPageView = createAction('dmg/TRACK_PAGE_VIEW');

export const trackHomePageView = createAction('/homepage/TRACK_PAGE_VIEW');

export const trackPromoPickerPageView = createAction(
  '/promo-picker/TRACK_PAGE_VIEW'
);
